import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import Pickup from '@/plugins/sdk/resources/Pickup'
import CarrierContact from '@/plugins/sdk/resources/Carrier/Contact'

export default class extends Resource {
  static name = 'pickup_notification'

  static get fields () {
    return {
      id: new UUID(),
      is_delivered: new BOOLEAN(),
      read_at: new DATETIME(),
      notified_at: new DATETIME(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      pickup: new ITEM(Pickup),
      carrier_contact: new ITEM(CarrierContact)
    }
  }
}
